<template>
    <div v-if="listready" class="wrapper">
        <div class="animated fadeIn">
            <b-card header="<i class='fa fa-align-justify'></i><strong> Bedrijven</strong>">
                <div class="wrapper" v-show="user.m >= 7">
                    <filter-form
                            :currentFilter="currentFilter"
                            @get-items="getItems">
                    </filter-form>
                    <br />
                </div>
                <item-list
                        :items="items"
                        @delete-item="deleteItem"
                        @destroy-item="destroyItem">
                </item-list>
            </b-card>
        </div>

        <b-modal title="Verwijderen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Dit bedrijf kan niet verwijderd worden! Aan dit bedrijf zijn nog andere gegevens gekoppeld. {{errormsg}}
        </b-modal>


        <b-modal title="Bedrijf verwijderen" size="sm" class="modal-primary" v-model="warningGeduld">
            <div slot="modal-footer" class="w-100"><p>Even geduld a.u.b.</p></div>
            <p><fadeloader :loading="loading" :size="size" :color="color" class="spinner"></fadeloader></p>
            <p>&nbsp;<br/>&nbsp;</p>
            <p>Bedrijf (incl. alle afdelingen en teelten) wordt verwijderd. Deze bewerking kan even duren.</p>
        </b-modal>

    </div>
</template>

<script>
    import api from '../../api/bedrijf';
    import FilterForm from './FilterForm';
    import ItemList from './List';
    import FadeLoader from 'vue-spinner/src/FadeLoader';

    export default {
        data () {
            return {
                warningModal: false,
                listready: false,
                errormsg: '',
                items: [],

                warningGeduld: false,
                loading: true,
                size: '20px',
                color: '#20a8d8',
            };
        },
        computed: {
            currentFilter () {
                const filter = this.$store.getters.bedrijfFilter;
                return Object.assign({}, filter);
            },
            user () {
                return this.$store.getters.user;
            },
        },
        created () {
            this.getItems();
        },
        methods: {
            getItems () {
                this.$store.dispatch('saveBedrijfFilter', this.currentFilter);
                api.getListBedrijf(this.currentFilter.zoekstring).then((response) => {
                    this.items = response.data.items;
                    this.listready = true;
                });
            },
            deleteItem (id) {
                api.deleteBedrijf(id).then(() => {
                    this.getItems();
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            destroyItem (id) {
                this.warningGeduld = true;
                api.destroyBedrijf(id).then(() => {
                        this.warningGeduld = false;
                        this.getItems(false);
                    },
                    (error) => {
                        this.warningGeduld = false;
                        this.errormsg = error.message;
                        this.warningModal = true;
                    });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'filter-form': FilterForm,
            'item-list': ItemList,
            fadeloader: FadeLoader,
        },
    };
</script>

<style>

    .spinner {
        margin-top: 30px;
        margin-bottom: 20px;
        margin-left:130px;
        color: #20a8d8;
    }

</style>



// WEBPACK FOOTER //
// src/pages/bedrijf/Index.vue